export default {"src":"/assets/turbo/929e56e7/baurde/_next/static/media/favicon.15b4e09a.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};